// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const triggerGoogleTagEvent = (event: string, record?: any) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    ...record
  });
};
